<template>
  <div class="subfund-crudblock">
    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      :page.sync="page"
      :search.sync="query"
      v-model="form"
      :before-open="beforeOpenScope"
      @on-load="onLoad"
      @search-change="searchChange"
      @search-reset="searchReset"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @sort-change="sortChange"
    >
      <template slot="menuLeft" slot-scope="{ row, size }">
        <el-button
          size="small"
          type="primary"
          v-if="permission.fdoffunds_add"
          icon="el-icon-plus"
          @click="handleAdd(-1)"
        >
          新增子基金</el-button
        >
        <el-button
          size="small"
          plain
          @click="exportShow"
          icon="el-icon-download"
          >导出数据</el-button
        >
        <el-button
          size="small"
          plain
          @click="showUpload"
          icon="el-icon-upload2"
          >导入模版</el-button
        >        
      </template>
      <template slot="search" slot-scope="{ row, size }">
        <div class="form_slot">
          <el-form-item label="基金规模">
            <el-input-number
              v-model="query.peScaleMin"
              :controls="false"
              placeholder="开始数值"
            />
            ~
            <el-input-number
              v-model="query.peScaleMax"
              :controls="false"
              placeholder="结束数值"
            />
          </el-form-item>
        </div>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="success"
          plain
          size="small"
          icon="el-icon-arrow-right"
          @click.stop="handleDetail(scope.row.id)"
          >详情
        </el-button>
        <el-button
          type="primary"
          plain
          size="small"
          icon="el-icon-edit"
          v-if="
            permission.fdoffunds_edit &&
            !(scope.row.auditState == 1 || scope.row.auditState == 2)&&
            scope.row.managerUser == userInfo.user_id
          "
          @click.stop="handleEdit(scope.row.id)"
          >编辑
        </el-button>

        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete-solid"
          v-if="permission.fdoffunds_delete && scope.row.auditState == 0 &&scope.row.managerUser == userInfo.user_id"
          @click.stop="handleDel(scope.row.id)"
          >删除
        </el-button>
      </template>
      <template slot="fundDetail" slot-scope="{ row }">
        <!-- <div class="fund-detail" v-if="row['auditState'] != 2">-</div> -->
        <div class="fund-detail">
          <span v-if="row['eventNum'] == 0" class="gray-text">暂无</span>
          <span v-else class="blue-text" @click="showEvent(row)">查看详情</span>
          <a-popover
            placement="right"
            trigger="hover">
            <template slot="content">
              <!-- <div class="fund-right-content" > -->
              <div class="fund-right-content">
                <el-button class="right-btn" type="text" size="small" @click="goAddEvent(0, row)">投资事件-股权投资</el-button>
                <el-button class="right-btn" type="text" size="small" @click="goAddEvent(1, row)">退出事件-股权退出</el-button>
                <el-button class="right-btn" type="text" size="small" style="margin-bottom:0 !important;" @click="goAddEvent(2, row)">分红</el-button>
              </div>
            </template>
            <i v-if="row.managerUser == userInfo.user_id" class="el-icon-plus plus-right" style="cursor:pointer;"></i>
          </a-popover>
        </div>
      </template>

      <template slot="searchMenu" slot-scope="{ row, size }">
        <el-button type="primary" @click="save(row)">保存</el-button>
      </template>
      <template slot="menuRight" slot-scope="scope">
        <el-tooltip class="item" effect="dark" content="显隐" placement="top">
          <el-button
            icon="el-icon-s-operation"
            circle
            @click="operation"
          ></el-button>
        </el-tooltip>
      </template>
    </avue-crud>

    <!-- 2021/12/24 新增数据导入 -->
    <uploadForm 
      uploadTitle="子基金模版导入"
      ref="uploadDialog"
      @refreshData='refreshList'
      uploadUrl="/api/fund/fdoffunds/import"
      openUrl="/api/fund/fdoffunds/export-template"
    />

    <ExportData ref="exportData" :isFundExport='true' @exportDownload="exportDownload" />
    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="true"
      :clear="false"
      @setPeople="setPeople"
    />
    <SelectDepartment
      ref="selectdepartment"
      :checkdepartment="checkdepartment"
      :isOnly="true"
      @setDepartment="setDepartment"
    />
    <Options
      ref="Options"
      :plainOptions="optionColumn"
      :pageDataId="this.$route.path"
      @returnData="returnData"
    />
  </div>
</template>

<script>
import * as api from "@/api/fund/subfunds";
import * as dictionaries from "@/api/zd/dictionaries";
import { mapGetters } from "vuex";
import { downLoadTemplate } from "@/router/downLoadTem";
import uploadForm from "@/components/uploadForm/uploadForm";
import ExportData from "@/components/exportData/exportData";
import SelectPerson from "@/components/SelectPersonnel/person";
import SelectDepartment from "@/components/SelectDepartment/department";
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import Options from "@/components/ShowHidden/showhidden";
import * as util from "@/util/util";
import moment from "moment";

export default {
  name: "subProjectManage",
  data() {
    return {
      optionColumn: [],
      drawer: false,
      shlb: 0,
      form: {},
      formScreen: {},
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      query: {},
      currentPage: 1,
      data: [],
      projectname: [],
      loading: false,
      option: {
        // excelBtn: true,
        menuType: "button",
        menuWidth: 260,
        menuAlign: "center",
        align: "center",
        card: true,
        columnBtn: false,
        searchBtn: true,
        refreshBtn: false,
        tip: false,
        lazy: true,
        simplePage: true,
        searchShow: true,
        searchMenuSpan: 6,
        tree: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        labelWidth: 100,
        // showSummary: true,

        column: [
          // {
          //   sortable: "custom",
          //   label: "基金编号",
          //   prop: "number",
          //   fixed: true,
          //   display: true,
          //   width: 140,
          // },
          {
            label: "基金名称",
            prop: "name",
            placeholder: "子基金名称",
            fixed: true,
            // hide: false,
            // hideshow: false,
            display: true,
            width: 180,
            search: true,
          },
          {
            label: "子基金名称",
            prop: "nameLabel",
            bind: "name",
            placeholder: "子基金名称",
            fixed: true,
            display: true,
            width: 180,
          },
          {
            label: "基金管理人",
            prop: "fdManagerName",
            display: true,
            width: 200,
          },          
          {
            label: "母基金名称",
            prop: "masterName",
            display: true,
            // fixed: true,
            width: 180,
          },
          {
            label: "投资/退出明细",
            bind: "fundDetail",
            prop: "fundDetail",
            width: 140,
            slot: true,
          },
          {
            label: "基金大类",
            prop: "fundTargetType",
            display: false,
            width: 110,
            formatter: (row, value, label, column) => {
              return value == 0?'纾困基金':value == 1 ?'政府产业基金':'-'
            }
          },
          {
            label: "基金类型",
            prop: "isDirectional",
            display: false,
            width: 110,
            formatter: (row, value, label, column) => {
              return value === 0?'非定向':value == 1 ?'定向':'-'
            }
          },          
          // {
          //   label: "审核状态",
          //   prop: "auditState",
          //   type: "select",
          //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
          //   props: {
          //     label: "dictValue",
          //     value: "dictKey",
          //   },
          //   formatter: (row, value, label, column) => {
          //     return value > -1 ? label : "-";
          //   },
          //   dataType: "string",
          //   search: true,
          //   display: true,
          // },
          {
            label: "基金认缴规模",
            prop: "peScale",
            display: false,
            width: 150,
            formatter: (row, value, label, column) => {
              return value == -1 ? "-" : this.getMoney(value) + "元";
            },
          },
          {
            label: "政府产业基金认缴额",
            prop: "govIndustrySubscribed",
            display: false,
            width: 150,
            formatter: (row, value, label, column) => {
              return value == -1 ? "-" : this.getMoney(value) + "元";
            },
          },
          {
            label: "政府产业基金出资占比",
            prop: "capitalRatio",
            display: true,
            width: 200,
            formatter: (row, value, label, column) => {
              return value > -1 ? value + "%" : "-";
            },
          },

          {
            label: "基金实缴金额",
            prop: "totalCapitalPaid",
            display: true,
            width: 150,
            formatter: (row, value, label, column) => {
              return value == -1 ? "-" : this.getMoney(value) + "元";
            },
          },
          {
            label: "政府产业基金实缴金额",
            prop: "realGovIndustrySubscribed",
            display: true,
            width: 150,
            formatter: (row, value, label, column) => {
              return value == -1 ? "-" : this.getMoney(value) + "元";
            },
          },
          {
            label: "项目总投资金额",
            prop: "allFundAmount",
            display: true,
            width: 150,
            formatter: (row, value, label, column) => {
              return value == -1 ? "-" : this.getMoney(value) + "元";
            },
          },
          {
            label: "设立时间",
            prop: "establishmentTime",
            display: false,
            width: 110,
          },
          {
            label: "基金状态",
            prop: "fundState",
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=fund_state",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            formatter: (row, value, label, column) => {
              return value > -1 ? label : "-";
            },
            dataType: "string",
            display: true,
          },
          // {
          //   label: "合作方式",
          //   prop: "cooperateType",
          //   type: "select",
          //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=cooperate_type",
          //   props: {
          //     label: "dictValue",
          //     value: "dictKey",
          //   },
          //   dataType: "string",
          //   display: true,
          //   search: true,
          //   formatter: (row, value, label, column) => {
          //     return value > -1 ? label : "-";
          //   },
          // },          
          {
            label: "基金对接人",
            prop: "managerName",
            display: true,
            width: 100,
          }          

          // {
          //   label: "操作时间",
          //   prop: "createTime",
          //   width: 220,
          //   display: false,
          //   formatter: (row, value, label, column) => {
          //     return value == -1 ? "-" : moment(value).format("YYYY-MM-DD");
          //   },
          // },
        ],
      },
    };
  },

  computed: {
    ...mapGetters(["permission", "userInfo"]),
  },
  watch: {
    files: {
      handler(newName, oldName) {
        if (oldName != undefined) {
          this.cloudTages(newName);
        }
      },

      immediate: true,
    },
  },
  props: ["files"],
  components: {
    TagsCloud,
    Options,
    SelectPerson,
    SelectDepartment,
    uploadForm,
    ExportData,
  },
  created() {
    this.optionColumn = this.deepClone(this.option.column)
  },
  activated() {
    this.onLoad(this.page);
  },
  methods: {
    refreshList() {
      this.onLoad(this.page);
    },
    showUpload() {
      this.$refs.uploadDialog.showModel()
    },
    //显隐
    operation() {
      let origencolum = this.option.column;
      this.$refs.Options.showmode();
    },
    returnData(data) {
      // console.log(data);
      // this.$emit("showoption",data)
      this.option.column = data;
    },
    onLoad(page) {
      api
        .getList({
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          ...this.query,
        })
        .then((res) => {
          this.auditlistNub = res.data.data.total;
          this.page.total = res.data.data.total;
          this.data = res.data.data.list;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    //通过名称获取菜单
    getFileMenuByName(fileMenuName, fileMenuUrlname) {
      dictionaries
        .getFileMenuByName({ fileMenuName, fileMenuUrlname })
        .then((res) => {
          this.baFileMenuId = res.data.data.id;
        })
        .catch((res) => {
          console.log(res);
        });
    },

    //排序
    sortChange(val) {
      this.query.orderValue =
        val.order == "descending"
          ? "desc"
          : val.order == "ascending"
          ? "asc"
          : "";

      this.query.orderName = val.prop;
      this.page.currentPage = 1;
      this.onLoad(this.page);
    },
    //搜索
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page);
      done();
    },
    searchReset() {
      this.query = {};
      this.drawer = false;
      this.onLoad(this.page);
      this.projectsearch("");
    },
    save(row) {
      this.$emit("rowdata", row);
    },
    cloudTages(data) {
      this.form = data;

      this.searchChange(data);
    },

    //显示高级筛选抽屉
    screen() {
      this.form = { ...this.form, ...this.query };
      this.drawer = true;
    },
    //高级筛选
    handleSearch(form, done, loading) {
      this.query = { ...this.query, ...form };
      this.drawer = false;
      this.page.currentPage = 1;
      this.onLoad(this.page);
      done();
    },
    //新增
    handleAdd(id) {
      // this.$refs.crud.rowEdit();
      this.$router.push({ path: `/fund/subfunds/add/${id}` });
    },

    //编辑
    handleEdit(id) {
      // this.$refs.crud.rowEdit();
      this.$router.push({ path: `/fund/subfunds/edit/${id}` });
    },
    //详情
    handleDetail(id) {
      this.$router.push({ path: `/fund/subfunds/detail/${id}` });
    },
    //删除
    handleDel(id) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return api.remove(id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.$refs.crud.toggleSelection();
        });
    },
    // 查看事件列表
    showEvent(data) {
      this.$router.push({
        path: `/fund/subfunds/detail/${data.id}`,
        query: {
          active: "list",
        },
      });
    },
    //投资/退出明细
    goAddEvent(type, row) {
      // this.visible = false
      // this.$refs['rightPop'].showPopper = false
      // console.log(`${row['name']}-${type == 0?'股权投资':type == 1?'股权退出':'分红'}`)
      // if(row.managerUser!=this.userInfo.user_id){
      //   this.$message({
      //   type: "warning",
      //   message: "您暂无权限进行此操作，请核对是否为其基金对接人。",
      //   });
      //   return
      // }
      this.$router.push({
          path: '/fund/investEventManage/add',
          query: {
            addType: type,
            id: row['id'],
            eventBelongType:2,
            projectName: `${row['name']}-${type == 0?'股权投资':type == 1?'股权退出':'分红'}`
          }
        })
      },
    exportShow() {
      this.$refs.exportData.showModel();
    },
    exportDownload(value) {
      let page = this.page;
      let data = {
        export: value.code,
      };
      if (value.code == 1) {
        data = {
          ...data,
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          ...this.query,
        };
      } else if (value.code == 2) {
        data = {
          ...data,
          ...this.query,
        };
      }
      if(value.code == 4){
        downLoadTemplate('/api/fund/fdoffunds/exportAll', {}).finally(() => {
          this.loading = false
          this.$message({
            type: "success",
            message: "已下载",
          });
        })
      }else{
        downLoadTemplate("/api/fund/fdoffunds/export", data).finally(() => {
          this.loading = false;
          this.$message({
            type: "success",
            message: "已下载",
          });
        });
      }
    },
  },
};
</script>

<style lang="scss">
.ant-popover-placement-right{
  width: 170px !important;
}
.subProjectManage {
  .blue-text{
    margin-right: 5px;
  }  
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .crudblock {
    background: #ffff;
    padding: 16px;
    border-radius: 4px;
  }
}
.subfund-crudblock {
  background: #ffff;
  padding: 16px;
  border-radius: 4px;
}
.none-border {
  border: 0;
  background-color: transparent !important;
}
.input_width {
  width: 220px;
}
.table_no_color {
  color: rgb(215, 215, 215);
}
.loadmores {
  display: inline-block;
  text-align: center;
  line-height: 35px;
  font-size: 15px;
  color: #697289;
  padding: 0 20px;
  width: 100%;
  cursor: pointer;
  font-weight: 600;
}
.advanced_screen {
  cursor: pointer;
}
.el-select-dropdown
  .el-scrollbar
  .el-scrollbar__view
  .el-select-dropdown__item {
  padding: 0 20px;
}
.fund-right-content {
  .right-btn {
    margin-left: 0 !important;
    margin-bottom: 10px;
    width: 100%;
    color: black;
    font-size: 14px;
  }
  .right-btn:hover {
    color: #64b0ff;
  }
}
.plus-right {
  color: #f56c6c !important;
  font-weight: 600;
  font-size: 16px;
}
.blue-text {
  // color: #64b0ff !important;
  margin-right: 5px;
  // text-decoration: underline;
  // cursor: pointer;
}
</style>

